<template>
  <div class="warp">
    <div class="login">
      <div class="login-title">
        {{ title }}
        <div>
          溯源管理平台
        </div>
      </div>
      <div class="login-con">
        <!-- 用户登录 -->
        <div class="login-p" v-if="isLogin">
          <div class="login-con-title">用户登录</div>
          <!-- <a-form
            style="margin-top: 40px;"
            id="components-form-demo-normal-login"
            :form="form"
            class="login-form"
            @submit="handleSubmit"
          > -->
          <a-form
            style="margin-top: 40px;"
            id="components-form-demo-normal-login"
            class="login-form"
          >
            <a-form-item>
              <a-input placeholder="请输入用户名" v-model="username" >
                <a-icon
                  slot="prefix"
                  type="user"
                  style="color: rgba(0,0,0,.25)"
                />
              </a-input>
            </a-form-item>
            <a-form-item>
              <a-input
                type="password"
                placeholder="请输入密码"
                v-model="password"
              >
                <a-icon
                  slot="prefix"
                  type="lock"
                  style="color: rgba(0,0,0,.25)"
                />
              </a-input>
            </a-form-item>
            <a-form-item style="text-align: right">
              <p class="login-form-forgot" @click="toPassword()">
                忘记密码
              </p>
            </a-form-item>
            <a-form-item>
              <a-button
                type="primary"
                html-type="submit"
                class="login-form-button"
                @click="handleSubmit()"
              >
                登 录
              </a-button>
            </a-form-item>
          </a-form>
        </div>
        <!-- 重置密码 -->
        <div class="forgetPassword-p" v-else>
          <div class="login-con-title">重置密码</div>
          <div class="forgetPassword-div">
            <input
              class="forgetPassword-input"
              type="text"
              v-model="phonenumber"
              :maxLength = "11"
              placeholder="手机号"
            />
          </div>
          <div class="forgetPassword-div">
            <input
              class="forgetPassword-input"
              type="text"
              v-model="verCode"
              placeholder="验证码"
            />
            <button
              v-if="!isCode"
              class="forgetPassword-button"
              @click="sendSms()"
            >
              获取验证码
            </button>
            <button v-if="isCode" class="forgetPassword-button disabled">
              {{ time }}秒后重新发送
            </button>
          </div>
          <div class="forgetPassword-div">
            <input
              class="forgetPassword-input"
              autocomplete="new-password"
              type="password"
              v-model="resetPassword"
              placeholder="新密码：8-16位字符，包含字母、数字和特殊字符"
            />
          </div>
          <a-form-item style="margin-top: 40px;">
            <a-button
              type="primary"
              html-type="submit"
              class="login-form-button"
              @click="resetSubmit()"
            >
              确 定
            </a-button>
            <div style="text-align: right">
              已有账号？<span
                style="cursor: pointer;color:#03BB7A"
                @click="toLogin()"
                >马上登录</span
              >
            </div>
          </a-form-item>
          <div></div>
        </div>
      </div>
      <!-- <button @click="handleSubmit()">333</button> -->
    </div>
    <div class="bottom">
      <div>
        备案号: 苏ICP备
      </div>
      <a href="https://beian.miit.gov.cn/" target="banck" class="bottom-a">
        <u>2024110524号-1</u>
      </a>
      <div>
        号
      </div>
      <div class="bottom-name">南京市</div>

    </div>
  </div>
</template>

<script type="text/javascript">
import userLogin from "@/api/login/index";
import { getMenuList } from "@/api/permission/menu/index";
import { changePassword,sendMessage } from "@/api/permission/user/index";
export default {
  name: "login",
  data() {
    return {
      timer: "", //验证码定时器
      isCode: false, //验证码点击切换展示
      time: "59", //验证码时间
      isLogin: true, //登录或者忘记密码
      username: "",
      password: "",
      resetPassword: "",
      phonenumber: "",
      verCode: "",
      admin: false,
      title: ""
    };
  },
  created() {
    // const host = window.location.host;
    // if (host.indexOf("nanjing") !== -1) {
    //   this.title = "南京市";
    // }

    this.title = "渠达自动化";
  },
  methods: {
    handleSubmit() {
      userLogin({
        userName: this.username,
        pwd: this.password
      }).then(res => {
        if (res.code == 0) {
          let permission = res.data.permissions;
          if (permission.indexOf("admin") !== -1) {
            this.admin = true;

            localStorage.setItem("detect_edit", true);
            localStorage.setItem("permission_edit", true);
          }
          else
          {
            localStorage.setItem("detect_edit", false);
            localStorage.setItem("permission_edit", false);
          }

		localStorage.setItem("token", res.data.token);	

          this.getMenus();
          this.getSysConfig();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    resetSubmit(){
      var formData = new FormData();
      formData.append("code", this.verCode);
      formData.append("password", this.resetPassword);
      formData.append("phone", this.phonenumber);
      changePassword(formData).then(res => {
        console.log(res);
        if (res.code == 0) {
          this.$message.success('密码修改成功！');
          this.time = "59";
          this.isCode = false;
          clearInterval(this.timer); //清除定时器
          this.isLogin = true;
          this.username= "";
          this.password= "";
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getMenus() {
      getMenuList().then(res => {

        console.log("===========================================")
        console.log(res)
        if (res.code == 0) {

          console.log("+++++++++++++++++++++++++++++++++++++++++")
          localStorage.setItem("menus", JSON.stringify(res.data));
        }
        // if (this.admin) {
        this.$router.push({ path: "/navigation" });
        // } else {
        //   this.$router.push({ path: "/index/dashboard" });
        // }
      });
    },
    getSysConfig() {
      localStorage.setItem("system_name", "南京市溯源系统");
    },
    sendSms() {
      if(this.phonenumber==''){
        this.$message.error("请输入手机号");
      }else{
      if (this.phonenumber!='' && !/^1[3456789]\d{9}$/.test(this.phonenumber)) {
        this.$message.error("请输入正确的手机号");
        return;
      }else{
          var formData = new FormData();
          formData.append("phone", this.phonenumber);
          sendMessage(formData).then(res => {
            if (res.code == 0) {
              console.log(res);
            } else {
              this.$message.error(res.message);
            }
          });
          this.time = "59";
          this.isCode = true;
          this.timer = setInterval(() => {
            this.time--;
            if (this.time == 0) {
              this.isCode = false;
              clearInterval(this.timer); //清除定时器
              return;
            }
          }, 1000);
        }
      }
    },
    toPassword() {
      this.isLogin = false;
      this.username= "";
      this.password= "";
    },
    toLogin() {
      this.isLogin = true;
    }
  }
};
</script>

<style scoped>
.login {
  width: 100%;
  height: 100vh;
  background: url(../../assets/img/login/bg.png) no-repeat;
  background-size: cover;
  background-position: center;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.login-title {
  font-size: 48px;
  color: #796f6b;
  text-align: center;
  /*width: 432px;*/
  margin-left: 280px;
}
.login-con {
  width: 457px;
  height: 460px;
  background: #ffffff;
  margin-right: 100px;
  box-sizing: border-box;
  padding: 50px;
  text-align: center;
}
.login-con-title {
  width: 256px;
  height: 72px;
  line-height: 72px;
  font-size: 28px;
  color: #232424;
  border-bottom: 2px solid #2593fc;
  margin: 0 auto;
}
.login-form-forgot {
  text-align: right;
  color: #1890ff;
  cursor: pointer;
}
.login-form-button {
  width: 100%;
  height: 40px;
}
.forgetPassword-div {
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #d4d9e2;
}
.forgetPassword-input {
  width: 100%;
  height: 36px;
  border: none;
  outline-style: none;
}
.forgetPassword-button {
  width: 140px;
  height: 36px;
  border-radius: 28px;
  background-color: rgba(255, 255, 255, 100);
  color: rgba(89, 157, 238, 100);
  font-size: 12px;
  text-align: center;
  box-sizing: border-box;
  margin-bottom: 10px;
  outline-style: none;
  border: 1px solid rgba(89, 157, 238, 100);
}
.disabled {
  width: 140px;
  height: 36px;
  background: rgba(0, 0, 0, 0.03);
  border: 1px solid #999999;
  font-size: 12px;
  color: #999999;
}
.bottom {
  position: fixed;
  bottom: 20px;
  left: 0px;
  width: 100%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
}
.bottom-a {
  color: #ffffff;
  margin: 0px 5px;
}
.bottom-name {
  margin-left: 20px;
}
</style>
